import { Building2, Stethoscope, Users } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const CARDS = [
  { icon: Building2, title: "Hospitals", desc: "Discuss your healthcare business or operational requirements.", cta: "Hospital Enquiry", testId: "ecosystem-cta-hospital-enquiry" },
  { icon: Stethoscope, title: "Healthcare Professionals", desc: "Connect, collaborate and share knowledge.", cta: "Professional Connect", testId: "ecosystem-cta-professional-connect" },
  { icon: Users, title: "Patients & General Public", desc: "Explore healthcare information and awareness resources.", cta: "Explore Healthcare Knowledge", testId: "ecosystem-cta-patient-knowledge" },
];

export const EcosystemCta = () => (
  <section id="ecosystem-cta" className="relative bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag index="11" label="Healthcare Ecosystem" />
        <h2 className="font-display mt-6 max-w-2xl text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
          Are You Part of the Healthcare Ecosystem?
        </h2>
        <p className="mt-5 max-w-2xl text-base text-[#4A6B82] sm:text-lg">
          Whether you are a hospital owner, healthcare professional, healthcare entrepreneur or
          an individual looking for healthcare-related information, we would like to connect.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.09}>
            <div className="group flex h-full flex-col rounded-2xl border border-[#0B3C5C]/10 bg-[#EAF3F8]/60 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-teal-500/30">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#5FA832]/10 transition-colors duration-300 group-hover:bg-[#5FA832]/20">
                <c.icon className="h-6 w-6 text-[#4C8F2F]" />
              </span>
              <h3 className="font-display mt-6 text-lg font-bold text-[#0B3C5C]">{c.title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-[#4A6B82]">{c.desc}</p>
              <a
                href={i === 2 ? "#knowledge" : "#enquiry"}
                data-testid={c.testId}
                className="mt-8 inline-flex w-fit items-center rounded-full border border-teal-500/40 px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] text-[#5FA832] transition-all duration-300 hover:bg-[#5FA832] hover:text-white"
              >
                {c.cta}
              </a>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
